
const React = require('react');
const Link = require('react-router-dom').Link;
// const Avatar = require('./commonControls.jsx.js').userAvatar;
const OneLineTextField = require('./commonControls.jsx.js').OneLineTextField;
const AjaxFunctions = require('../ajaxFunctions');
const Toastr = require('toastr');
const HopscotchTours = require('../hopscotchTours.js');
const Hopscotch = require('hopscotch');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('../redux/reduxStore.jsx.js');
const SharedConstants = require('../../../../shared/sharedConstants');
const TextInputModal = require('./textInputModal.jsx.js').TextInputModal;
const ToastAlert = require('./toastAlert');
import Tooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Badge from '@material-ui/core/Badge';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField';
import { Toolbar, AppBar, Typography, SvgIcon, Hidden, Drawer, ListItem, List } from '@material-ui/core';
import { UserAvatarV2 } from './commonControls.jsx.js';
import { error } from 'toastr';

class SignInDialog extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         username: '',
         password: '',
      }
   }

   handleClose() {
      this.props.onClose();
   };

   onLinkedInClicked(){
      window.location.href = '/auth/linkedin';
   }

   async doLogin() {
      try {
         let loginData = await AjaxFunctions.login(this.state.username, this.state.password);
         window.globals.idUser = loginData.user.idUser;
         window.globals.hasCompletedIntro = loginData.hasCompletedIntro;
         this.props.reloadAllData();
         this.handleClose();
      }
      catch (err) {
         this.setState({ loginError: err });
      }
   }

   render() {
      const { loginError } = this.state;
      return (
         <Dialog
            open={this.props.open}
            maxWidth={'sm'}
            fullWidth
            onClose={() => this.handleClose()}
            onEscapeKeyDown={() => this.handleClose()}
            onBackdropClick={() => this.handleClose()}
         >
            <DialogContent className={'sign-in-dialog'}>
               <Typography variant="h5" style={{color: '#4457CF', marginBottom: '1em'}}>
                  New to PolyPlexus?
               </Typography>
               <div>
                  Create an account to get started today.
               </div>
               <Button
                  onClick={() => { window.location = '/register'}}
                  color='primary'
                  variant="outlined"
                  style={{ marginRight: 10, backgroundColor: '#4457CF' }}
               >
                  <Typography variant="body2" style={{ color: 'white' }}>
                     Sign In
                  </Typography>
               </Button>
               <hr />
               <Typography variant="h5" style={{color: '#4457CF', marginBottom: '1em'}}>
                  Registered User
               </Typography>
               <div>
                  Have an account? Sign in now.
               </div>
               <div>
                  <TextField
                     variant="outlined"
                     id='loginDialogUsername'
                     placeholder={'Email'}
                     fullWidth
                     value={this.state.username}
                     onChange={(event) => this.setState({username: event.target.value})}
                     maxLength="100"
                     label='Email'
                  />
               </div>
               <br/>
               <div>
                  <TextField
                     variant="outlined"
                     id='loginDialogPassword'
                     placeholder={'Password'}
                     fullWidth
                     value={this.state.password}
                     onChange={(event) => this.setState({password: event.target.value})}
                     maxLength="100"
                     label='Password'
                     type='password'
                     onKeyUp={(event) => (event.key === 'Enter') ? this.doLogin() : {}}
                  />
               </div>
               <Button href={'/users/forgotPassword'} color='primary'>
                  <Typography variant="body2">
                     Forgot Password?
                  </Typography>
               </Button>
            </DialogContent>
            <DialogActions style={{padding: 20, justifyContent: 'space-between' }}>
               <div>
                  <span>{loginError}&nbsp;</span>
                  {loginError == SharedConstants.AccountNotVerifiedText && (
                     <Button color='primary' className='material-button' onClick={async () => {
                        try{
                           await AjaxFunctions.resendVerificationEmail(this.state.username);
                           ToastAlert.success("Account verification email sent successfully.")
                        }catch(err){
                           ToastAlert.error("Error sending account verification email.")
                        }
                     }}>
                        <Typography variant="body2">
                           Resend Verification?
                        </Typography>
                     </Button>
                  )}
               </div>
               <div>
                  <Button
                     disabled={this.state.username == "" || this.state.password == ""}
                     onClick={() => this.doLogin()}
                     color='primary'
                     variant="outlined"
                     style={{ marginRight: 10, backgroundColor: '#4457CF' }}
                  >
                     <Typography variant="body2" style={{ color: 'white' }}>
                        Sign In
                     </Typography>
                  </Button>
                  <Button onClick={() => this.handleClose()} color='primary' variant="outlined">
                     <Typography variant="body2">
                        Cancel
                     </Typography>
                  </Button>
               </div>
            </DialogActions>
            <div>
               <input
                  style={{float: 'right', margin: '10px'}}
                  type={'image'}
                  src={'https://content.linkedin.com/content/dam/developer/global/en_US/site/img/signin-button.png'}
                  onClick={() => this.onLinkedInClicked()}
               >
               </input>
            </div>
            {/*
            <div>
               <a href='/auth/orcid'>
                  <img
                     style={{float: 'right', width: '215px', margin: '10px'}}
                     src={'https://plexus-static.s3.us-west-2.amazonaws.com/unversioned/images/Orcid_Button.png'}
                  />
               </a>
            </div>
            */}
         </Dialog>
      );
   }
}

class UserPanel extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         showUserInfo: false,
         userInfoAnchorElement: null,
         showSignInModal: false,
      }
   }

   openUserInfo(userInfoAnchorElement) {
      this.setState({
         userInfoAnchorElement,
         showUserInfo: true,
      })
   }

   render() {
      if (this.props.userData && this.props.userData.idUser) {
         return (
            <div>
               <Button className="material-button navbar-shadow-button" onClick={(e) => this.openUserInfo(e.target)} style={{ textTransform: 'none', marginRight: '1em', marginLeft: '1em' }}>
                  <Typography style={{ color: 'white', fontSize: '13px' }} noWrap>
                     {`${this.props.userData.firstName}  `} <FontAwesomeIcon size={'sm'} icon={['far', `chevron-${this.state.showUserInfo ? 'up' : 'down'}`]} color={"#0BBDD1"} transform="grow-2" />
                  </Typography>
               </Button>
               <Button className="material-button" component={Link} to='/users/profile'>
                  <UserAvatarV2 userData={this.props.userData} />
               </Button>
                  <IconButton className="material-button" color="inherit"  component={Link} to='/messages' >
                     <Badge badgeContent={this.props.userData.unreadPrivateMessageCount} color="secondary" >
                        <FontAwesomeIcon size={'sm'} icon={['far', "bell"]} color={"white"} />
                     </Badge>
                  </IconButton>

               <Popover
                  id={'userInfoPopover'}
                  open={this.state.showUserInfo}
                  anchorEl={this.state.userInfoAnchorElement}
                  anchorOrigin={{
                     vertical: 'bottom',
                     horizontal: 'left',
                  }}
                  onClose={() => this.setState({ showUserInfo: false })}
               >
                  <UserInfo userData={this.props.userData} />
               </Popover>
            </div>
         )
      }
      return (
         <div>
            <Button
               className="material-button navbar-shadow-button"
               onClick={() => this.setState({ showSignInModal: true })}
               style={{ marginRight: '1em', marginLeft: '1em' }}
               id={'headerSignInButton'}
            >
               <Typography style={{ color: 'white', fontSize: '13px', fontWeight: 'bolder' }} noWrap>
                  Sign In
               </Typography>
            </Button>
            <Button className="material-button navbar-shadow-button" href={'/register'}>
               <Typography component="p" style={{ color: 'white', fontSize: '13px', fontWeight: 'bolder' }} noWrap>
                  Register
               </Typography>
            </Button>
            <SignInDialog
               open={this.state.showSignInModal}
               onClose={() => this.setState({ showSignInModal: false })}
               reloadAllData={() => location.reload()}
            />
         </div>
      )
   }
}


export class TopBarV2 extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         showAlertsPopup: false,
         anchorElement: this,
         suggestionOpened: false,
         showUserInfo: false,
         userInfoAnchorElement: null,
      }
   }

   openUserInfo(userInfoAnchorElement) {
      this.setState({
         userInfoAnchorElement,
         showUserInfo: true,
      })
   }

   render() {
      return (
         <AppBar
            position="fixed"
            className={clsx(this.props.classes.appBar)}
         >
            <Toolbar>
               <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={() => this.props.menuClick()}
                  edge="start"
                  size="small"
                  className={clsx(this.props.classes.menuButton, "material-button")}
                  style={{ marginLeft: '-10px', marginRight: '28px' }}
               >
                  <FontAwesomeIcon icon={['fas', "bars"]} />
               </IconButton>
               <Link to='/' className='top-bar-logo-link'>
                  <img
                     src={window.globals.STATIC_ASSETS_BASE_URL + '/unversioned/images/logo-white.svg'}
                     alt=''
                     style={{ height: 60 }}
                  />
               </Link>
               <div style={{ flex: 1 }} />
               <UserTab />
            </Toolbar>
         </AppBar>
      );
   }
}

function UserTabBase(props) {
   return (
      <UserPanel
         userData={props.userData}
         reloadAllData={() => console.log("Reload")}
      />
   );
}

const IncubatorListItemsStateToProps = (state) => {
   return {
      userData: state.UserReducer.curUser,
      unreadPrivateMessageCount: state.UserReducer.curUser.unreadPrivateMessageCount
   }
};


const UserTab = connect(
   IncubatorListItemsStateToProps,
   () => { }
)(UserTabBase);


function UserInfo(props) {
   return (
      <div style={{ backgroundColor: '#4457CF' }}>
         <List>
            <ListItem>
               <Button href={'/users/profile'} className="material-button navbar-shadow-button" style={{ textTransform: 'none', display: 'flex' }}>
                  <Typography style={{ color: 'white', fontSize: '13px', width: '85px', textAlign: 'left' }} noWrap>
                     View Profile
                  </Typography>
                  <FontAwesomeIcon size={'sm'} icon={['fas', `user`]} color={"white"} transform="grow-2" />
               </Button>
            </ListItem>
            <ListItem>
               <Button href={'/editProfile'} className="material-button navbar-shadow-button" style={{ textTransform: 'none', display: 'flex' }}>
                  <Typography style={{ color: 'white', fontSize: '13px', width: '85px', textAlign: 'left' }} noWrap>
                     Settings
                  </Typography>
                  <FontAwesomeIcon size={'sm'} icon={['fas', `cog`]} color={"white"} transform="grow-2" />
               </Button>
            </ListItem>
            <ListItem>
               <Button href={'/logout'} className="material-button navbar-shadow-button" style={{ textTransform: 'none', display: 'flex' }}>
                  <Typography style={{ color: 'white', fontSize: '13px', width: '85px', textAlign: 'left' }} noWrap>
                     Sign out
                  </Typography>
                  <FontAwesomeIcon size={'sm'} icon={['fas', `sign-out-alt`]} color={"white"} transform="grow-2" />
               </Button>
            </ListItem>
         </List>
      </div>
   );
}
